'use client';

import RoundArrowIcon from '@/components/ui/RoundArrowIcon/RoundArrowIcon';
import { useCallback, useEffect, useState } from 'react';
import styles from './ScrollToTopButton.module.scss';

function ScrollToTopButton({ threshold = 1000 }: { threshold?: number }) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > threshold);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [threshold]);

  const scrollToTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  if (!isVisible) return null;

  return (
    <button type='button' className={styles.button} onClick={scrollToTop} aria-label='ページの先頭に戻る'>
      <RoundArrowIcon direction='up' color='black' borderColor='black' size='xLarge' />
    </button>
  );
}

export default ScrollToTopButton;
